import React from 'react';
import styles from './index.module.scss';
import cn from 'classnames';
import uuid from 'react-uuid';
import { IFooterBase } from './store';
import ChevronRight from '~/common/components/ui-elements/svg-icon/svgs/ChevronRight';
import ImgLazyLoad from '~/common/components/image-lazy-loading';
export const FooterCTAsection = (props: IFooterBase) => {
  return (
    <>{props.showFooter?.toLowerCase() === 'true' && <Results {...props} />}</>
  );
};
const FirstCTA = (props: IFooterBase) => (
  <div className={styles.BrocAndDlr2_inner_btn1}>
    <div className={styles.BrocAndDlr2_inner_btn1_container}>
      <div>
        <a
          href={props.firstCTALink}
          className={styles.BrocAndDlr2_inner_btn1_link}
        >
          <span className={styles.BrocAndDlr2_inner_btncta_container}>
            <span className={styles.BrocAndDlr2_inner_btncta}>
              {props.firstCTAText}
            </span>
            <i>
              <ChevronRight color="#222222" className={styles.ChevronRight} />
            </i>
          </span>
        </a>
        <p
          className={styles.BrocAndDlr2_inner_btn1_learnmore}
          dangerouslySetInnerHTML={{
            __html: props.firstCTALearnMore as string,
          }}
        />
      </div>
    </div>
  </div>
);
const SecondCTA = (props: IFooterBase) => (
  <div className={styles.BrocAndDlr2_inner_btn2}>
    <div className={styles.BrocAndDlr2_inner_btn2_container}>
      <div>
        <a
          href={props.secondCTALink}
          className={styles.BrocAndDlr2_inner_btn2_link}
        >
          <span className={styles.BrocAndDlr2_inner_btncta_container}>
            <span className={styles.BrocAndDlr2_inner_btncta}>
              {props.secondCTAText}
            </span>
            <i>
              <ChevronRight color="#222222" className={styles.ChevronRight} />
            </i>
          </span>
        </a>
        <p
          className={styles.BrocAndDlr2_inner_btn2_learnmore}
          dangerouslySetInnerHTML={{
            __html: props.secondCTALearnMore as string,
          }}
        />
      </div>
    </div>
  </div>
);
const Results = (props: IFooterBase) => (
  <div key={uuid()} className={cn('full-device-width', styles.BrocAndDlr2)}>
    <div className={styles.BrocAndDlr2_inner}>
      <div className={styles.BrocAndDlr_container}>
        {props.image && (
          <div className={styles.BrocAndDlr_container_box1}>
            <div className={styles.BrocAndDlr2_inner1}>
              <ImgLazyLoad
                src={props.image || ''}
                className={styles.BrocAndDlr2_inner_img}
                loading="lazy"
              />
              {props.disclaimer && (
                <span
                  className={styles.BrocAndDlr2_inner1_disclaimer}
                  style={{ color: `#${props.disclaimerColor}` || '#000000' }}
                  dangerouslySetInnerHTML={{
                    __html: props.disclaimer as string,
                  }}
                />
              )}
            </div>
          </div>
        )}
        <div className={styles.BrocAndDlr_container_box2}>
          <div
            className={cn(styles.BrocAndDlr2_inner_ctas, {
              [styles.Center_ctas]: !props.image,
            })}
          >
            {props.showFirstCTA?.toLowerCase() === 'true' && (
              <FirstCTA {...props} />
            )}
            {props.showSecondCTA?.toLowerCase() === 'true' && (
              <SecondCTA {...props} />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);
